/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import './css/Product.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../../Admin/Config/Config';
import Loading from '../../assets/Loading/Loading';
import { useRelatedProducts } from './RelatedProducts/RelatedProducts';
import { useToast } from '../../Toast.jsx/Toast';
import { useCart } from './CartContext';
import { onAuthStateChanged } from 'firebase/auth';
import PriceGenerator from './PriceOperation/PriceGenerator';
import { useDocData } from '../../user/UserProvider';

export default function View() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const { showWarning } = useToast();
  const userData = useDocData();
  const navigate = useNavigate();
  const { relatedProducts, fetchRelatedProductsByIds } = useRelatedProducts();
  const { addToCart } = useCart();
  const [mainImage, setMainImage] = useState("");
  const [product, setProduct] = useState({});

  const imageRef = useRef(null);
  const containerRef = useRef(null);
  const rafRef = useRef(null);

  const handleMouseEnter = () => {
    if (imageRef.current) {
      imageRef.current.style.transition = "transform 0.2s cubic-bezier(0.25, 1, 0.5, 1)";
      imageRef.current.style.transform = "scale(2.5)";
    }
  };

  const handleMouseLeave = () => {
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    if (imageRef.current) {
      imageRef.current.style.transition = "transform 0.3s cubic-bezier(0.25, 1, 0.5, 1), transform-origin 0.3s ease-out";
      imageRef.current.style.transform = "scale(1)";
      imageRef.current.style.transformOrigin = "center center";
    }
  };

  const handleMouseMove = (e) => {
    if (!containerRef.current || !imageRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
    const y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));

    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      if (imageRef.current) {
        imageRef.current.style.transition = "none";
        imageRef.current.style.transformOrigin = `${x}% ${y}%`;
      }
    });
  };
  // =============================== User Details ================================ //

  useEffect(() => {
    // Scroll to top when component mounts or location changes
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    setLoading(true);
    const params = new URLSearchParams(location.search);
    const queryParam = params.get("query");

    onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userRef);

        if (userDoc.exists()) {
          if (queryParam) {
            fetchProduct(queryParam, userDoc.data());
          }
        }
      } else {
        if (queryParam) {
          fetchProduct(queryParam);
        }
      }
    });
  }, [location]);
  // =============================== Fetch Product ================================ //
  const fetchProduct = async (query, userDetails) => {
    const docSnap = await getDoc(doc(db, "products", query));
    let offer_price = 0;
    let original_price = 0;
    if (auth.currentUser && userDetails.uid && userDetails.schemeId) {
      const priceRef = doc(
        db,
        "product_price",
        userDetails?.schemeId,
        "products",
        query
      );
      const priceSnap = await getDoc(priceRef);
      offer_price = priceSnap.exists() ? priceSnap.data().offer_price : 0;
      original_price = priceSnap.exists() ? priceSnap.data().original_price : 0;
    }
    if (docSnap.exists()) {
      if (docSnap.data().relatedProducts) {
        await fetchRelatedProductsByIds(docSnap.data().relatedProducts);
      }
      const img = new Image();
      setProduct({ ...docSnap.data(), id: docSnap.id, offer_price, original_price });
      setMainImage(docSnap.data().product_images[0]);
      img.src = docSnap.data().product_images[0];
      img.onload = () => setLoading(false);
    }
  };



  useEffect(() => {
    if (!loading) {
      // Ensure scroll to top after content has loaded
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [loading]);

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span
        key={index}
        className={`text-lg ${index < rating ? "text-red-500" : "text-gray-300"}`}
      >
        ★
      </span>
    ));
  };

  const handleDivClick = (id) => {
    // Scroll to top before navigating
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    navigate(`/view?query=${encodeURIComponent(id)}`);
  };


  const [quantities, setQuantities] = useState({});
  const getQuantity = (productId) => quantities[productId] || 1;

  const updateQuantity = (productId, newQuantity) => {
    console.log(newQuantity);
    if (newQuantity >= 1 && newQuantity <= 99) {
      setQuantities(prev => ({
        ...prev,
        [productId]: newQuantity
      }));
    }
  };
  const handleAddToCart = async (e, pro) => {
    e.stopPropagation();
    const quantity = getQuantity(pro.id);
    const productWithQuantity = { ...pro, cart_quantity: quantity };
    if (pro.stock >= 1) {

      if (!auth.currentUser) {
        await addToCart("", productWithQuantity);
      } else {
        await addToCart(auth.currentUser.uid, productWithQuantity);
      }
    } else {
      showWarning("Out of stock");
    }
  };

  if (loading) return <Loading />;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

        {/* Breadcrumbs */}
        <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-8 bg-white p-4 rounded-lg border border-gray-200">
          <button
            onClick={() => navigate('/')}
            className="hover:text-red-600 transition-colors duration-200 font-medium"
          >
            Home
          </button>
          <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
          <button
            onClick={() => navigate('/products')}
            className="hover:text-red-600 transition-colors duration-200 font-medium"
          >
            Products
          </button>
          <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
          {product.brand && (
            <>
              <span className="text-gray-500 font-medium">{product.brand}</span>
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </>
          )}
          <span className="text-gray-900 font-semibold truncate max-w-xs">
            {product.product_name}
          </span>
        </nav>

        {/* Main Product Section */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-12 mb-16">

          {/* Product Images */}
          <div className="space-y-4">
            <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
              <div
                ref={containerRef}
                className="relative p-4 flex justify-center items-center overflow-hidden cursor-zoom-in min-h-[350px] select-none"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onMouseMove={handleMouseMove}
              >
                <div className="absolute top-4 left-4 z-20 flex flex-col items-start bg-white/90 backdrop-blur-md px-3 py-1.5 rounded-xl shadow-sm border border-slate-200/60 hover:shadow-md transition-shadow duration-300 pointer-events-none">
                  <span className="text-[10px] uppercase font-extrabold text-slate-400 tracking-wider leading-none mb-0.5">Code</span>
                  <span className="text-sm font-bold text-slate-700 font-mono leading-none">
                    {product?.product_code_sku || "N/A"}
                  </span>
                </div>
                <img
                  ref={imageRef}
                  src={mainImage}
                  alt={product.product_name || "Product"}
                  style={{
                    transformOrigin: "center center",
                    transform: "scale(1)",
                    willChange: "transform, transform-origin"
                  }}
                  className="w-full h-[320px] sm:h-[400px] object-contain pointer-events-none"
                />
              </div>
            </div>

            {/* Gallery Thumbnails */}
            {product?.product_images?.length > 1 && (
              <div className="flex items-center gap-3 overflow-x-auto pt-1 pb-1">
                {product.product_images.map((imgUrl, idx) => (
                  <button
                    key={idx}
                    onClick={() => setMainImage(imgUrl)}
                    className={`relative w-16 h-16 sm:w-20 sm:h-20 rounded-xl overflow-hidden border-2 transition-all duration-300 flex-shrink-0 bg-white ${
                      mainImage === imgUrl ? "border-red-600 scale-105 shadow-md" : "border-slate-200 hover:border-slate-400"
                    }`}
                  >
                    <img src={imgUrl} alt={`Thumbnail ${idx + 1}`} className="w-full h-full object-contain p-1" />
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Product Details */}
          <div className="space-y-8">

            {/* Product Header */}
            <div className="space-y-4">
              <div className="space-y-2">
                <h1 className="text-2xl font-bold text-gray-900 leading-tight">
                  {product.product_name}
                </h1>
                <p className="text-xs font-semibold text-red-600 uppercase tracking-wide">
                  {product.brand}
                </p>
              </div>

              {/* Rating and Quantity Info */}
              <div className="bg-white p-4 rounded-lg border border-gray-200">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-2">
                      <div className="flex items-center">
                        {renderStars(product.rating)}
                      </div>
                      <span className="text-xs font-semibold text-gray-700">
                        {product.rating}/5
                      </span>
                    </div>
                    <div className="w-px h-4 bg-gray-300"></div>
                    <div className="flex items-center gap-2">
                      <svg className="w-3 h-3 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                      </svg>
                      <span className="text-xs font-semibold text-gray-700">
                        {product.quantity} {product.measure_unit}
                      </span>
                    </div>
                  </div>

                  {/* Stock Status */}
                  <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold ${product.stock > 0
                    ? "bg-green-100 text-green-800 border border-green-200"
                    : "bg-red-100 text-red-800 border border-red-200"
                    }`}>
                    <div className={`w-1.5 h-1.5 rounded-full mr-1.5 ${product.stock > 0 ? "bg-green-600" : "bg-red-600"
                      }`}></div>
                    {product.stock > 0 ? "In Stock" : "Out of Stock"}
                  </div>
                </div>
              </div>
            </div>

            {/* Pricing Section */}
            <div className="bg-gradient-to-r from-red-50 to-red-100 border border-red-200 p-4 rounded-lg">
              <PriceGenerator product={product} userDetails={userData} />
            </div>

            {/* Add to Cart Button */}
            <button
              onClick={(e) => handleAddToCart(e, product)}
              disabled={product.stock <= 0}
              className={`w-full py-3 px-4 font-semibold text-sm transition-all duration-200 rounded-lg ${product.stock > 0
                ? "bg-red-600 hover:bg-red-700 text-white transform hover:scale-105"
                : "bg-gray-300 text-gray-600 cursor-not-allowed"
                }`}
            >
              <div className="flex items-center justify-center gap-2">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 2.5M7 13l2.5 2.5" />
                </svg>
                {product.stock > 0 ? "Add to Cart" : "Out of Stock"}
              </div>
            </button>

            {/* Product Information */}
            <div className="space-y-4">

              {/* Specifications */}
              {product?.specifications?.length > 0 && (
                <div className="bg-white border border-gray-200 p-4 rounded-lg">
                  <h3 className="text-base font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <svg className="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Specifications
                  </h3>
                  <div className="grid grid-cols-1 gap-2">
                    {product.specifications.map((item, index) => (
                      <div key={index} className="bg-gray-50 border border-gray-200 p-3 rounded-lg">
                        <p className="text-gray-800 font-medium text-sm">{item.field_value}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Product Details */}
              <div className="bg-white border border-gray-200 p-4 rounded-lg">
                <h3 className="text-base font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <svg className="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Product Details
                </h3>
                <div className="bg-gray-50 p-4 rounded-lg">
                  {product?.about_product?.length > 0 ? (
                    <ul className="space-y-2">
                      {product.about_product.map((item, index) => (
                        <li key={index} className="flex items-start gap-2">
                          <div className="w-1.5 h-1.5 bg-red-600 rounded-full mt-1.5 flex-shrink-0"></div>
                          <span className="text-gray-800 leading-relaxed text-xs">{item}</span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-gray-500 italic text-xs">No information available</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Related Products */}
        {relatedProducts?.length > 0 && (
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-bold text-gray-800 flex items-center gap-2">
                <svg className="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                Related Products
              </h2>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
              {relatedProducts.map((product) => {
                const hasDiscount = product.stock > 0 && ((product.original_price - product.offer_price) / product.original_price) * 100 >= 10;
                const isOutOfStock = product.stock <= 0;

                return (
                  <div
                    key={product.id}
                    onClick={() => handleDivClick(product.id)}
                    className="group relative bg-white border border-red-500 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-xl hover:-translate-y-1 hover:border-red-600 flex flex-col justify-between"
                  >
                    {/* Gradient overlay */}
                    <div className="absolute inset-0 bg-gradient-to-br from-slate-50/50 via-transparent to-slate-100/30 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>

                    {/* Product Image Portion (White) */}
                    <div className="relative w-full h-24 sm:h-32 p-2 bg-white flex justify-center items-center overflow-hidden">
                       {product.product_code_sku && (
                        <div className="absolute top-1.5 right-1.5 z-20 flex items-center bg-white/95 backdrop-blur-md px-1.5 py-0.5 rounded-md shadow-xs border border-slate-300/80 transition-all duration-300 group-hover:border-red-200 group-hover:bg-red-50/90">
                          <span className="text-[10px] sm:text-xs font-bold text-slate-700 font-mono leading-none group-hover:text-red-600 transition-colors duration-200">
                            {product?.product_code_sku || "N/A"}
                          </span>
                        </div>
                      )}

                      <img
                        src={product.thumb_url}
                        alt={product.product_name}
                        className="w-full h-full object-contain transition-all duration-500 group-hover:scale-110"
                      />
                    </div>

                    {/* Stock/Discount Badge */}
                    {isOutOfStock ? (
                      <div className="absolute top-1 left-1 z-20 bg-red-500 text-white py-0.5 px-1.5 rounded-full text-xs font-bold">
                        Out of stock
                      </div>
                    ) : (
                      hasDiscount && (
                        <div className="absolute top-1 left-1 z-20 bg-red-600 text-white py-0.5 px-1.5 rounded-full text-xs font-bold">
                          {(((product.original_price - product.offer_price) / product.original_price) * 100).toFixed(0)}% OFF
                        </div>
                      )
                    )}

                    {/* Product Info Portion (Light Beige Two-Tone) */}
                    <div className="relative z-10 p-2.5 bg-[#faf6f0] border-t border-amber-100/70 flex-1 flex flex-col justify-between space-y-1.5">
                      <div>
                        {/* Product Name */}
                        <h3 className="text-xs sm:text-sm font-semibold text-slate-700 leading-tight group-hover:text-slate-900 transition-colors duration-300 line-clamp-2 min-h-[1.8rem] sm:min-h-[2.5rem]">
                          {product.product_name.length > 45
                            ? `${product.product_name.slice(0, 45)}...`
                            : product.product_name}
                        </h3>

                        {/* Brand & Price in same row */}
                        <div className="flex items-center justify-between gap-1 mt-1 min-h-[1.5rem]">
                          {product.brand ? (
                            <div className="text-[10px] font-bold uppercase tracking-wider text-red-600 bg-red-50 border border-red-100 rounded px-1.5 py-0.5 inline-block w-max truncate">
                              {product.brand}
                            </div>
                          ) : (
                            <div />
                          )}
                          <PriceGenerator product={product} userDetails={userData} priceOnly={true} />
                        </div>
                      </div>

                      {/* Quantity & Cart Section */}
                      <div className="flex items-center justify-between gap-2">
                        {/* Quantity Selector */}
                        <div className="flex items-center bg-white border border-slate-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 w-full max-w-[180px]">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              updateQuantity(product.id, getQuantity(product.id) - 1);
                            }}
                            className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 text-slate-500 hover:text-slate-700 hover:bg-slate-50 transition-all duration-200 rounded-l-lg group"
                            disabled={getQuantity(product.id) <= 1}
                          >
                            <svg
                              className="w-3 h-3 sm:w-4 sm:h-4 transition-transform group-active:scale-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M20 12H4" />
                            </svg>
                          </button>

                          <div className="flex-1 flex items-center justify-center h-8 sm:h-10 text-slate-800 font-semibold text-sm sm:text-base bg-slate-50 border-l border-r border-slate-200">
                            {getQuantity(product.id)}
                          </div>

                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              updateQuantity(product.id, getQuantity(product.id) + 1);
                            }}
                            className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 text-slate-500 hover:text-slate-700 hover:bg-slate-50 transition-all duration-200 rounded-r-lg group"
                            disabled={getQuantity(product.id) >= 99}
                          >
                            <svg
                              className="w-3 h-3 sm:w-4 sm:h-4 transition-transform group-active:scale-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                            </svg>
                          </button>
                        </div>

                        {/* Add to Cart Button */}
                        <button
                          onClick={(e) => handleAddToCart(e, product)}
                          className="relative flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 bg-gradient-to-r from-slate-700 to-slate-800 hover:from-slate-800 hover:to-slate-900 text-white rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-slate-400/30 active:scale-95 group/btn"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4 sm:w-4 sm:h-4 transition-transform duration-300 group-hover/btn:scale-110 group-hover/btn:rotate-12"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m0 0H17M9 19.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM20 19.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
                            />
                          </svg>

                          {/* Tooltip */}
                          <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 bg-slate-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap opacity-0 group-hover/btn:opacity-100 transition-opacity duration-200 pointer-events-none z-20">
                            Add to Cart
                            <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-2 border-transparent border-t-slate-800"></div>
                          </div>
                        </button>
                      </div>



                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}